import { getIsWixApp, getShowConsentBehaviour } from '../selectors/appRuntimeReader';
import { ShowConsentBehaviour } from '@wix/ambassador-devcenter-appsruntimereader-v1-app-runtime-data/types';
export const shouldShowConsent = (app, version) => {
  const showConsentBehavior = getShowConsentBehaviour(app);
  const isWixApp = getIsWixApp(app);
  if (version === 'dev') {
    return false;
  }
  if (showConsentBehavior === ShowConsentBehaviour.SHOW_CONSENT) {
    return true;
  }
  if (showConsentBehavior === ShowConsentBehaviour.SKIP_CONSENT) {
    return false;
  }
  return !isWixApp;
};
//# sourceMappingURL=consent.js.map